import { excelService, ioService } from 'services'
import { ProcessRowData } from 'view/shared/incomingUpload'
import { parseClipboard } from 'view/shared/upload/model'
import { RowData, transformCurveImportData } from './parseCurveUtils'

export const processCurveFileClipboardToRowData: ProcessRowData = async ({ uploadFile, clipboard }) => {
  if (uploadFile) {
    const curveRowData = (await excelService.parseXlsx(await ioService.readFile(uploadFile), {
      asArray: true,
      fileType: uploadFile.type
    })) as RowData
    return transformCurveImportData(curveRowData)
  } else if (clipboard) {
    const curveRowData = parseClipboard(clipboard, { header: false }) as RowData
    return transformCurveImportData(curveRowData)
  }
  return []
}
